import { isRouteErrorResponse, Link, useRouteError } from 'react-router-dom';

/**
 * The router's `errorElement`: catches render-time crashes and thrown responses so one broken
 * page degrades to a message instead of a blank document.
 */
export function RouteErrorPage() {
  const error = useRouteError();
  const status = isRouteErrorResponse(error) ? error.status : undefined;

  return (
    <div className="page page--narrow">
      <h1>{status === 404 ? 'Page not found' : 'Something broke'}</h1>
      <p>
        {status === 404
          ? "That page doesn't exist."
          : 'Sorry — that page failed to load. Reloading usually fixes it.'}
      </p>
      <p>
        <Link to="/">Back to upcoming events</Link>
      </p>
    </div>
  );
}
